<template>
  <!-- 外部链接用 <a> 标签 -->
  <a v-if="isExternalLink" :href="to" target="_blank" rel="noopener">
    <slot />
  </a>
  
  <!-- 内部路由用 <router-link> -->
  <router-link v-else v-bind="$props" custom v-slot="{ href, navigate, isActive }">
    <a :href="href" @click="navigate" :class="isActive ? 'router-link-active' : ''">
      <slot />
    </a>
  </router-link>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  name: 'AppLink',
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    isExternalLink() {
      return isExternal(this.to)
    }
  }
}
</script>